import React from 'react';
import useTranslation from '../hooks/useTranslation';

interface ScreenshotReceivedPopupProps {
  isVisible: boolean;
  onClose: () => void;
}

const ScreenshotReceivedPopup: React.FC<ScreenshotReceivedPopupProps> = ({
  isVisible,
  onClose,
}) => {
  const { t } = useTranslation();
  
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-sm w-full mx-4 p-6 text-center">        
        {/* 메인 타이틀 */}
        <h2 className="text-xl font-bold text-gray-900 mb-4">
          {t('popup.screenshot.title')}
        </h2>
        
        {/* 모래시계 아이콘과 설정 시간 */}
        <div className="flex items-center justify-center mb-2">
          <span className="text-lg mr-2">⏳</span>
          <span className="text-gray-700 font-medium">
            {t('popup.screenshot.setupTime')}
          </span>
        </div>
        
        {/* 알림 메시지 */}
        <p className="text-gray-600 mb-4">
          {t('popup.screenshot.notification')}
        </p>
        
        {/* 이미지 삭제 안내 */}
        <p className="text-xs text-gray-500">
          {t('popup.screenshot.imageDelete')}
        </p>
        
        {/* 닫기 버튼 (임시로 추가, 나중에 자동 닫기로 변경 가능) */}
        <button
          onClick={onClose}
          className="mt-6 w-full py-2 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 text-sm"
        >
          {t('popup.screenshot.confirm')}
        </button>
      </div>
    </div>
  );
};

export default ScreenshotReceivedPopup; 